import { css } from "@emotion/css";

export const _OverlayArrow = () => {
  return (
    <div className={styles.overlayWrapper}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.vectorGraphic}
      >
        <g clipPath="url(#clip0_13356_3545)">
          <g filter="url(#filter0_dd_13356_3545)">
            <path
              d="M10.7071 6.29289L17 0L3 -6.47957e-07L9.29289 6.29289C9.68342 6.68342 10.3166 6.68342 10.7071 6.29289Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dd_13356_3545"
            x="-7"
            y="-5"
            width="34"
            height="26.5858"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_13356_3545"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_13356_3545"
              result="effect2_dropShadow_13356_3545"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_13356_3545"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_13356_3545">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.vectorGraphic}
      >
        <g filter="url(#filter0_dd_19503_10601)">
          <path
            d="M10.7071 6.29289L17 0L3 -6.47957e-07L9.29289 6.29289C9.68342 6.68342 10.3166 6.68342 10.7071 6.29289Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_dd_19503_10601"
            x="-7"
            y="-5"
            width="34"
            height="26.5859"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_19503_10601"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_19503_10601"
              result="effect2_dropShadow_19503_10601"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_19503_10601"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

const styles = {
  overlayWrapper: css({
    position: "relative",
  }),
  vectorGraphic: css({
    position: "absolute",
  }),
};
